import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_1cb4de8f-8c80-44d3-8d05-6a8d3846de63/artifacts/73t9klvs_NEW%20PWC%20LOGO%20jpeg.jpeg";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-[#2A2A2A]" data-testid="footer">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            {/* Company Info */}
            <div>
              <img 
                src={LOGO_URL} 
                alt="PWC Fabrication & Engineering" 
                className="h-12 w-auto mb-6 bg-white p-1 rounded"
              />
              <p className="text-[#A3A3A3] text-sm leading-relaxed">
                Quality fabrication and engineering services for farmers, contractors, 
                and equipment owners across the Great Southern region.
              </p>
              <div className="flex items-center gap-4 mt-6">
                <a 
                  href="https://www.facebook.com/61574081204175/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="p-2 bg-[#1A1A1A] border border-[#2A2A2A] rounded-xl hover:border-[#E63946] transition-colors"
                  data-testid="facebook-link"
                >
                  <Facebook size={20} className="text-[#A3A3A3] hover:text-white" />
                </a>
                <a 
                  href="https://www.instagram.com/pwc_fab_engineering?utm_source=qr&igsh=MXJoNWV0ODB4cXZzMA==" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="p-2 bg-[#1A1A1A] border border-[#2A2A2A] rounded-xl hover:border-[#E63946] transition-colors"
                  data-testid="instagram-link"
                >
                  <Instagram size={20} className="text-[#A3A3A3] hover:text-white" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-bold text-lg uppercase tracking-wider mb-6 text-white">
                Quick Links
              </h4>
              <ul className="space-y-3">
                {["Home", "Services", "Products", "About", "Contact"].map((link) => (
                  <li key={link}>
                    <Link 
                      to={link === "Home" ? "/" : `/${link.toLowerCase()}`}
                      className="text-[#A3A3A3] hover:text-[#E63946] transition-colors text-sm"
                      data-testid={`footer-link-${link.toLowerCase()}`}
                    >
                      {link}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="font-bold text-lg uppercase tracking-wider mb-6 text-white">
                Services
              </h4>
              <ul className="space-y-3">
                {[
                  { name: "Welding & Fabrication", id: "welding-fabrication" },
                  { name: "Custom Attachments", id: "custom-attachments" },
                  { name: "Livestock Infrastructure", id: "livestock-infrastructure" },
                  { name: "CAD Design", id: "cad-design" },
                  { name: "Mobile Onsite Welding", id: "mobile-welding" }
                ].map((service) => (
                  <li key={service.id}>
                    <Link 
                      to={`/services#${service.id}`}
                      className="text-[#A3A3A3] hover:text-[#E63946] transition-colors text-sm"
                    >
                      {service.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="font-bold text-lg uppercase tracking-wider mb-6 text-white">
                Contact Us
              </h4>
              <ul className="space-y-4">
                <li>
                  <a 
                    href="tel:0402275003" 
                    className="flex items-center gap-3 text-[#A3A3A3] hover:text-white transition-colors"
                    data-testid="footer-phone"
                  >
                    <Phone size={18} className="text-[#E63946]" />
                    <span>0402 275 003</span>
                  </a>
                </li>
                <li>
                  <a 
                    href="mailto:phillip.pwc@gmail.com" 
                    className="flex items-center gap-3 text-[#A3A3A3] hover:text-white transition-colors"
                    data-testid="footer-email"
                  >
                    <Mail size={18} className="text-[#E63946]" />
                    <span>phillip.pwc@gmail.com</span>
                  </a>
                </li>
                <li className="flex items-start gap-3 text-[#A3A3A3]">
                  <MapPin size={18} className="text-[#E63946] mt-1 flex-shrink-0" />
                  <span>Great Southern, Western Australia</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-12 pt-8 border-t border-[#2A2A2A] flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#525252] text-sm">
              © {new Date().getFullYear()} PWC Fabrication & Engineering. All rights reserved.
            </p>
            <p className="text-[#525252] text-sm">
              Precision Fabrication. Built to Last.
            </p>
          </div>

          {/* Made by Layerly */}
          <div className="mt-6 text-center">
            <a 
              href="https://www.layerly.info" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#525252] text-xs hover:text-[#E63946] transition-colors"
              data-testid="made-by-layerly"
            >
              Made by Layerly
            </a>
          </div>
        </div>
      </footer>
  );
}
